import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import personFieldModel from "@app/util/fieldModel/PersonFieldModel";
import { convertToPlatformFilterModel } from "@app/util/viewModel/convertToPlatformFilterModel";

// The $filters the people list fetches with; the chat context sends the same object.
const buildPeopleListFilters = (
  filter: FilterModel,
  columns: ColumnModel
): PlatformFilterModel => ({
  includeAccessStatus: true,
  includeEmailSubscriptionStatus: true,
  ...convertToPlatformFilterModel(filter, columns, personFieldModel),
});

export default buildPeopleListFilters;
